var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center w-full flex-col gap-2 p-16"},[_c(_setup.Icon,{staticClass:"text-4xl text-gray-dark",attrs:{"icon":_setup.icon}}),_c('p',{staticClass:"text-default"},[_vm._v(_vm._s(_setup.title))]),_c('p',{staticClass:"text-default text-center"},[_vm._v(_vm._s(_setup.subtitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }